import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./BoardsHero.css";

import heroImg from "../../../../../assets/images/allproducts/boards/boardshero.png";

const BoardsHero = () => {
  const { t } = useTranslation();

  return (
    <section className="boardsHero" aria-label="Boards category">
      <div className="boardsHero-container">
        <div className="boardsHero-left">
          <span className="boardsHero-tag">{t("sections.products.boards.tag")}</span>

          <h1 className="boardsHero-title">{t("sections.products.boards.title")}</h1>

          <p className="boardsHero-desc">{t("sections.products.boards.desc")}</p>

          <Link className="boardsHero-link" to="/products">
            {t("sections.products.boards.exploreAll")}
            <span className="arrow">↓</span>
          </Link>
        </div>

        <div className="boardsHero-right">
          <img src={heroImg} alt="" draggable={false} />
        </div>
      </div>
    </section>
  );
};

export default BoardsHero;
